// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".HistoryTable-module-historyTable-1lR_z{width:100%;padding:20px}@media(min-width: 768px){.HistoryTable-module-historyTable-1lR_z{padding-block:0;padding-inline:26px 5px}}.HistoryTable-module-historyTable-1lR_z tbody{display:flex;flex-direction:column;gap:8px}", ""]);
// Exports
exports.locals = {
	"historyTable": "HistoryTable-module-historyTable-1lR_z"
};
module.exports = exports;
